// TYPES
export const GET_APPLICATION_FIRST_MENU_LIST = 'GET_APPLICATION_FIRST_MENU_LIST';
export const GET_APPLICATION_MENU_LIST = 'GET_APPLICATION_MENU_LIST';
export const GET_APPLICATION_MENU_DETAIL = 'GET_APPLICATION_MENU_DETAIL';
export const SAVE_APPLICATION_MENU = 'SAVE_APPLICATION_MENU';
export const UPDATE_SEARCH_MENU_INFO = 'UPDATE_SEARCH_MENU_INFO';
export const GET_APPLICATION_MENU_EXCELDOWN = 'GET_APPLICATION_MENU_EXCELDOWN';
export const UPDATE_MENU_INFO = 'UPDATE_MENU_INFO';
export const SAVE_MENU_INFO = 'SAVE_MENU_INFO';
export const DEL_APPLICATION_MENU = 'DEL_APPLICATION_MENU';
export const UPDATE_SAVE_MENU_INFO_CLEAR = 'UPDATE_SAVE_MENU_INFO_CLEAR';
export const GET_MENU_LIST = 'GET_MENU_LIST';
export const SAVE_APPLICATION_MENU_UPDOWN = 'SAVE_APPLICATION_MENU_UPDOWN';
export const GET_APPLICATION_MENU_LIST_SORT = 'GET_APPLICATION_MENU_LIST_SORT';
export const UPDATE_SEARCH_MENU_INFO_CLEAR = 'UPDATE_SEARCH_MENU_INFO_CLEAR';

// 메뉴 목록 첫 조회
export const getApplicationFirstMenuList = payload => {    
    return { type: GET_APPLICATION_FIRST_MENU_LIST, payload };
};

// 메뉴 목록 조회
export const getMenuList = payload => {
    
    return { type: GET_MENU_LIST, payload };
}

// 메뉴 목록 조회
export const getApplicationMenuList = payload => {
    
    return { type: GET_APPLICATION_MENU_LIST, payload };
};

// 메뉴 상세 조회
export const getApplicationMenuDetail = payload => {
    return { type: GET_APPLICATION_MENU_DETAIL, payload };
};


export const updateSearchMenuInfo = payload => {
    return { type: UPDATE_SEARCH_MENU_INFO, payload };
};


export const updateMenuInfo = payload => {
    return { type: UPDATE_MENU_INFO, payload };
};


//메뉴 저장
export const saveApplicationMenu = payload => {
    return { type: SAVE_APPLICATION_MENU, payload };
};


//메뉴 엑셀다운로드
export const getApplicationMenuExcelDown = payload => {
    return { type: GET_APPLICATION_MENU_EXCELDOWN, payload };
};


//메뉴 신규등록
export const saveApplicationMenuInfo = payload => {
    return { type: SAVE_MENU_INFO, payload };
};

//메뉴 삭제
export const delApplicationMenu = payload => {
    return { type: DEL_APPLICATION_MENU, payload };
};


export const updateSaveApplicationMenuInfoClear = payload => {
    return { type: UPDATE_SAVE_MENU_INFO_CLEAR, payload };
};


export const saveApplicationMenuUpDown = payload => {
    return { type: SAVE_APPLICATION_MENU_UPDOWN, payload };
};


// 메뉴 목록 조회(순서용)
export const getApplicationMenuListSort = payload => {
    
    return { type: GET_APPLICATION_MENU_LIST_SORT, payload };
};


export const updateSearchMenuInfoClear = payload => {
    
    return { type: UPDATE_SEARCH_MENU_INFO_CLEAR, payload };
};